// generated by genversion
export var version = '5.2.4';
//# sourceMappingURL=version.js.map